module.exports = __webpack_public_path__ + "static/media/BN.56ebf9f5.png";